import { useEffect, useState } from "react"
import AddModel from "./AddModel"
import { useDispatch, useSelector } from "react-redux";
import userProfileSelectors from '../../../../../../redux/UserProfile/selectors'
import SuccessBee from "../../../../../assets/images/SuccessBee.svg";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import { getCatalogRemoveModel, getCatalogUpdateModel, getCatalogUpdateModelSave, setCatalogRemoveModel, setCatalogUpdateModelSave, setCatalogUpdateModelValidate } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction";
import { getModelsBasedOnMake } from "Store/Component/CatalogManagement/CatalogManagementAction";
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { popupInitialData } from "utils";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AddModelContainer = (props: any) => {
  const {
    setSelectedModel,
    setSelectedMake,
    selectedModel,
    selectedMake,
    ExistingDropDownValue,
    setShowAddModelModal,
    catalogItemValues,
    modelError,
    validateModel,
    setModelMakeError,
    modelMakeError,
    selectedAssetType
  } = props
  const [makeList, setMakeList] = useState<any>();
  const dispatch = useDispatch();

  const {
    catalogUpdateMake,
    userData,
    isCatalogUpdateModelValid,
    isCatalogModelRemoved,
    isCatalogUpdateModelSaved,
  }: any = useSelector(
    (state: any) => ({
      catalogUpdateMake: state.CatalogDropDownUpdateReducers.catalogUpdateMake,
      userData: userProfileSelectors.getUserDetails(state),
      isCatalogUpdateModelValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateModelValid,
      isCatalogModelRemoved: state.CatalogDropDownUpdateReducers.isCatalogModelRemoved,
      isCatalogUpdateModelSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateModelSaved
    })
  )

  const [PopupcontentComplete, setPopupcontentComplete] = useState<any>(popupInitialData);

  const hideDialogComplete = () => {
    setPopupcontentComplete({ ...PopupcontentComplete, isDialogVisible: false })
  };

  useEffect(() => {
    if (isCatalogUpdateModelSaved && isCatalogUpdateModelSaved != null) {
      let decriptionTxt = (<p>Model is added successfully.</p>);
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: SuccessBee,
        title: "SUCCESS",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          hideDialogComplete()
          setShowAddModelModal(false)
          setSelectedModel("")
          setSelectedMake('')
          if (catalogItemValues?.make?.value) {
            dispatch(getModelsBasedOnMake(catalogItemValues?.make?.value, catalogItemValues?.vehicleType?.label))
          } else if(catalogItemValues?.manufacturer?.value){
            dispatch(getModelsBasedOnMake(catalogItemValues?.manufacturer?.value, catalogItemValues?.vehicleType?.label))
          }
            dispatch(setCatalogUpdateModelSave(null))
        }
      });
    } else if (!isCatalogUpdateModelSaved && isCatalogUpdateModelSaved != null) {
      let decriptionTxt = (<p>Error Occured while adding the value.</p>);
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          hideDialogComplete()
          setSelectedMake("")
          setSelectedModel('')
          dispatch(setCatalogUpdateModelSave(null))
        }
      });
    }
  }, [isCatalogUpdateModelSaved])

  useEffect(() => {
    if (isCatalogModelRemoved && isCatalogModelRemoved != null) {
      let decriptionTxt = (<p>Value is removed successfully.</p>);
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: SuccessBee,
        title: "SUCCESS",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          hideDialogComplete()
          if (catalogItemValues?.make?.value) {
            dispatch(getModelsBasedOnMake(catalogItemValues?.make?.value, catalogItemValues?.vehicleType?.label))
          }
          let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
          dispatch(getCatalogUpdateModel(subTypeId, AttributeName.MODEL))
        }
      });
    } else if (!isCatalogModelRemoved && isCatalogModelRemoved != null) {
      let decriptionTxt = (<p>Error Occured while removing the value.</p>);
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          hideDialogComplete()
          dispatch(setCatalogRemoveModel(null))
        }
      });
    }
  }, [isCatalogModelRemoved])

  useEffect(() => {
    let isCatalogUpdateModelValidtemp = isCatalogUpdateModelValid?.filter((item: any) => !item?.isValid)
    if (isCatalogUpdateModelValidtemp?.length == 0 && isCatalogUpdateModelValid != null) {
      let makeIds: any = []
      selectedMake?.map((makeVal?: any) => {
        makeIds.push(parseInt(makeVal?.key))
      })
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getCatalogUpdateModelSave({
        savedBy: userData?.emailId,
        value: selectedModel,
        parentIds: makeIds,
        subTypeId: parseInt(subTypeId),
        isEquipment: selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? false : true,
        attributeName: AttributeName.MODEL
      }))
      dispatch(setCatalogUpdateModelValidate(null))
    } else if (isCatalogUpdateModelValidtemp?.length && isCatalogUpdateModelValid != null) {
      let value = ""
      isCatalogUpdateModelValidtemp?.map((itemVal: any) => {
        value = value.concat(`${(value ? ', ' : '') + itemVal?.make}`)
      })
      let decriptionTxt = (<p>Model value given already exists for <b>{value}</b>.</p>);
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          hideDialogComplete()
          setSelectedMake("")
          setSelectedModel('')
        }
      });
      dispatch(setCatalogUpdateModelValidate(null))
    }

  }, [isCatalogUpdateModelValid])

  useEffect(() => {
    if (catalogUpdateMake) {
      let catalogUpdateMakeTemp = catalogUpdateMake ? JSON.parse(JSON.stringify(catalogUpdateMake)) : [];
      let options = catalogUpdateMakeTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setMakeList(options)
    }
  }, [catalogUpdateMake])

  const handleModelChange = (e: any) => {
    validateModel(e?.target?.value)
    setSelectedModel(e?.target?.value)
  }

  const handleMakeChange = (value: any) => {
    if (value?.length > 0) {
      setModelMakeError("")
    }
    setSelectedMake(value)
  }

  const removeItem = (item?: any) => {
    if (!isAuthorized(permissions.CreateEditCatalog)) return;
    dispatch(getCatalogRemoveModel({
      savedBy: userData?.emailId,
      valueId: item?.value
    }))
  }

  return (
    <AddModel
      makeList={makeList}
      selectedMake={selectedMake}
      selectedModel={selectedModel}
      handleModelChange={handleModelChange}
      handleMakeChange={handleMakeChange}
      removeItem={removeItem}
      ExistingDropDownValue={ExistingDropDownValue}
      modelError={modelError}
      hideDialogComplete={hideDialogComplete}
      PopupcontentComplete={PopupcontentComplete}
      modelMakeError={modelMakeError}
    />
  )
}

export default AddModelContainer